module.exports = __webpack_public_path__ + "img/signature-raluca.30feb270.gif";